import bem from "easy-bem";
import React, { useState } from "react";

import type { SortDirection, SortField } from "./SortToggle.types";

import "./SortToggle.css";

const cn = bem("sort-toggle");

type SortToggleProps = {
  onSortChange?: (
    field: SortField,
    direction: SortDirection,
    groupByCase: boolean,
  ) => void;
  initialField?: SortField;
  initialDirection?: SortDirection;
  initialGroupByCase?: boolean;
  initialShowList?: boolean;
  onDisplayModeChange?: (showList: boolean) => void;
  /** "small" — компактные кнопки меньшей высоты, занимают меньше по вертикали */
  size?: "default" | "small";
};

const SortToggle: React.FC<SortToggleProps> = ({
  onSortChange,
  onDisplayModeChange,
  initialField = "dateCreated",
  initialDirection = "desc",
  initialGroupByCase = false,
  initialShowList = false,
  size = "default",
}) => {
  const [sortField, setSortField] = useState<SortField>(initialField);
  const [sortDirection, setSortDirection] =
    useState<SortDirection>(initialDirection);
  const [groupByCase, setGroupByCase] = useState<boolean>(initialGroupByCase);
  const [_showList, setShowList] = useState<boolean>(initialShowList);

  const handleFieldClick = (field: SortField) => {
    if (field === sortField) {
      // Повторный клик по тому же полю — меняем направление
      const newDirection = sortDirection === "asc" ? "desc" : "asc";
      setSortDirection(newDirection);
      onSortChange?.(field, newDirection, groupByCase);
    } else {
      // Другое поле — переключаемся на него с направлением desc по умолчанию
      setSortField(field);
      setSortDirection("desc");
      onSortChange?.(field, "desc", groupByCase);
    }
  };

  const _handleGroupByCaseChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newGroupByCase = e.target.checked;
    setGroupByCase(newGroupByCase);
    onSortChange?.(sortField, sortDirection, newGroupByCase);
  };

  const _handleShowListChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newShowList = e.target.checked;
    setShowList(newShowList);
    onDisplayModeChange?.(newShowList);
  };

  return (
    <div className={cn({ small: size === "small" })}>
      <button
        className={cn("button", {
          active: sortField === "dateCreated",
          asc: sortField === "dateCreated" && sortDirection === "asc",
          desc: sortField === "dateCreated" && sortDirection === "desc",
        })}
        onClick={() => handleFieldClick("dateCreated")}
      >
        Создано
        {sortField === "dateCreated" && (
          <span className={cn("arrow")}>
            {sortDirection === "asc" ? "↑" : "↓"}
          </span>
        )}
      </button>
      <button
        className={cn("button", {
          active: sortField === "dateModified",
          asc: sortField === "dateModified" && sortDirection === "asc",
          desc: sortField === "dateModified" && sortDirection === "desc",
        })}
        onClick={() => handleFieldClick("dateModified")}
      >
        Изменено
        {sortField === "dateModified" && (
          <span className={cn("arrow")}>
            {sortDirection === "asc" ? "↑" : "↓"}
          </span>
        )}
      </button>

      {/* <label className={cn("checkbox-label")}>
        <input
          type="checkbox"
          className={cn("checkbox")}
          checked={groupByCase}
          onChange={handleGroupByCaseChange}
        />
        <span className={cn("checkbox-text")}>Группировать по кейсу</span>
      </label> */}

      {/* <label className={cn("checkbox-label")}>
        <input
          type="checkbox"
          className={cn("checkbox")}
          checked={showList}
          onChange={handleShowListChange}
        />
        <span className={cn("checkbox-text")}>Показывать списком</span>
      </label> */}
    </div>
  );
};

export default SortToggle;
